import React from 'react'
import type { CuratedFeedSource } from '@/services/curatedFeedService'

interface SourceFilterProps {
  sources: CuratedFeedSource[]
  value: string | undefined
  onChange: (sourceId: string | undefined) => void
  disabled?: boolean
}

const SourceFilter: React.FC<SourceFilterProps> = ({ sources, value, onChange, disabled }) => {
  if (sources.length === 0) return null

  return (
    <label className="flex items-center gap-2 text-xs text-gray-700">
      <span>Source</span>
      <select
        aria-label="Filter by source"
        value={value ?? ''}
        disabled={disabled}
        onChange={(e) => onChange(e.target.value || undefined)}
        className="rounded-md border border-gray-300 bg-white px-2 py-1 text-xs text-gray-700 disabled:opacity-50"
      >
        <option value="">All sources</option>
        {sources.map((source) => (
          <option key={source.id} value={source.id}>
            {source.name}
          </option>
        ))}
      </select>
    </label>
  )
}

export default SourceFilter
